import React from 'react'
import styles from './deleteModal.module.css';
import { Close, Deletemodal } from '../../Svg';

const DeleteModal = ({ isOpen, onClose, onDelete,heading }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button onClick={onClose} className={styles.closeButton}>  <Close onClick={onClose} /></button>
                <div className={styles.modalContentDetails}>
                    <Deletemodal  />
                    <div className={styles.modalHeader}>
                        <h2>Delete User</h2>
                    </div>
                    <div className={styles.modalBody}>
                        <p>Do you want to delete this user</p>
                    </div>
                    <div className={styles.modalFooter}>
                        <button onClick={onClose} className={styles.cancelButton} >Cancel</button>
                        <button onClick={onDelete} className={styles.deleteButton}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
